import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmplitudeService } from '@inyova/inyova-shared';

@Component({
  selector: 'app-verify',
  standalone: false,
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.scss'
})
export class VerifyComponent implements OnInit {
  readonly route: ActivatedRoute = inject(ActivatedRoute);
  readonly router: Router = inject(Router);
  readonly amplitudeService: AmplitudeService = inject(AmplitudeService);

  status: 'success' | 'expired' | 'invalid';
  content: {
    iconColor: 'success' | 'warning' | 'critical';
    icon: string;
    title: string;
    subtitle: string;
    buttonText: string;
  };

  ngOnInit() {
    this.status = this.route.snapshot.paramMap.get('status') as 'success' | 'expired' | 'invalid';
    this.content = this.getContentBasedOnStatus(this.status);
  }

  onNavigate(status: 'success' | 'expired' | 'invalid') {
    if (status === 'expired' || status === 'invalid') {
      this.amplitudeService.trackEvent('Email Confirmation Requested', {
        send_reason: status === 'expired' ? 'expired_link_resend' : 'invalid_link_resend'
      });
    }
    void this.router.navigate(['/']);
  }

  getContentBasedOnStatus(status: 'success' | 'expired' | 'invalid'): {
    iconColor: 'success' | 'warning' | 'critical';
    icon: string;
    title: string;
    subtitle: string;
    buttonText: string;
  } {
    switch (status) {
      case 'success':
        return {
          iconColor: 'success',
          icon: 'circle-check',
          title: 'ONBOARDING.emailValidation.ConfirmationMessage',
          subtitle: 'ONBOARDING.emailValidation.ConfirmationDescription',
          buttonText: 'ONBOARDING.emailValidation.ButtonLabel.54'
        };

      case 'expired':
        return {
          iconColor: 'warning',
          icon: 'triangle-alert',
          title: 'ONBOARDING.emailValidation.ExpirationMessage',
          subtitle: 'ONBOARDING.emailValidation.ForYourSecurityConfirmationLinksExpireAfter',
          buttonText: 'ONBOARDING.emailValidation.ButtonLabel.54'
        };

      case 'invalid':
        return {
          iconColor: 'critical',
          icon: 'triangle-alert',
          title: 'ONBOARDING.emailValidation.InvalidMessage',
          subtitle: 'ONBOARDING.emailValidation.ThisLinkMayBeIncompleteOrAlreadyReplacedBy',
          buttonText: 'ONBOARDING.emailValidation.ButtonLabel'
        };
    }
  }
}
